import React, { useState, useMemo } from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Chip,
  Divider,
  TextField,
  InputAdornment,
  Tooltip,
  IconButton,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
} from "@mui/material";

import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import CheckIcon from "@mui/icons-material/Check";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

import AddHoursPage from "../Adding/addHOP/addhours";
import EditHoursPage from "../Editing/editHOP/edithours";
import "./displayhours.css";
import { axiosInstance } from "../../services/axiosInstance";
import { endpoints } from "../../services/endpoint";

const HoursOperationPage = ({ data = [], accountNo }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [showAddForm, setShowAddForm] = useState(false);
  const [hopList, setHopList] = useState(Array.isArray(data) ? data : []); 
  console.log(hopList)
  const [editinghours, setEditinghours] = useState(null);
  const [customHoursData, setCustomHoursData] = useState({});

  const instanceAlias = localStorage.getItem("instanceName");
  const username = localStorage.getItem("username")
  const instanceId = localStorage.getItem("InstanceId");
  const customerAWSAccountId = localStorage.getItem("CustomerAWSAccountId");
  const region = localStorage.getItem("Region");
  const EncryptedInstanceId = localStorage.getItem("EncryptedId")
  const [copiedArn, setCopiedArn] = useState("");
  const [confirmDeleteHour, setConfirmDeleteHour] = useState(null);
    const [actionClicked, setActionClicked] = useState(null);
  // Changed: Use hop name instead of ID for tracking deletion state
  const [deletingHopName, setDeletingHopName] = useState(null);
  const email = localStorage.getItem("Email");

  // ✅ Handle search
  const handleSearchChange = (e) =>
    setSearchQuery(e.target.value.toLowerCase());

  // ✅ Add new HOP
  const handleHoursAdded = (updatedList) => {
    setHopList(updatedList || []); // safe
    setShowAddForm(false);
  };

  // ✅ Update existing HOP
  const handleHoursUpdated = (updatedList) => {
    setHopList(updatedList || []);
    setEditinghours(null);
  };

  // ✅ Copy ARN
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedArn(text);
      setTimeout(() => setCopiedArn(""), 1500);
    });
  };

  // ✅ Filtered data always safe
  const filteredData = useMemo(() => {
    if (!Array.isArray(hopList)) return [];
    if (!searchQuery) return hopList;
    return hopList.filter(
      (hop) =>
        hop.name?.toLowerCase().includes(searchQuery) ||
        hop.description?.toLowerCase().includes(searchQuery) ||
        hop.timeZone?.toLowerCase().includes(searchQuery) ||
        hop.arn?.toLowerCase().includes(searchQuery)
    );
  }, [hopList, searchQuery]);

  // ✅ Fetch HOP list (returns array)
  const fetchHoursOfOperation = async () => {
  const payload = {
    InstanceAlias: instanceAlias,
    awsAccount: customerAWSAccountId,
    region,
    ID: EncryptedInstanceId,
  };

  try {
    const response = await axiosInstance.post(
      endpoints.displaylisthop.dipslayhopdata,
      payload
    );

    if (!response.data?.body) {
      console.warn("⚠️ No body in API response");
      return [];
    }

    // ✅ Body is an ARRAY (stringified)
    const parsedBody =
      typeof response.data.body === "string"
        ? JSON.parse(response.data.body)
        : response.data.body;

    if (!Array.isArray(parsedBody)) {
      console.warn("⚠️ Body is not an array");
      return [];
    }

    return parsedBody.map((item) => {
      // ✅ Safe tag handling
      let tagsFormatted = "No tags";
      if (
        item.Tags &&
        typeof item.Tags === "string" &&
        item.Tags.trim() !== "-" &&
        item.Tags.trim() !== ""
      ) {
        tagsFormatted = item.Tags;
      } else if (item.Tags && typeof item.Tags === "object") {
        tagsFormatted = Object.entries(item.Tags)
          .map(([k, v]) => `${k}: ${v}`)
          .join(", ");
      }

      return {
        id: item.Arn, // ✅ ARN instead of HOPId
        name: item.Name,
        description: item.Description || "No description",
        tags: tagsFormatted,
        timeZone: item.TimeZone || "No timezone",
        config: item.Config || [],
        lastModifiedTime: item.LastModifiedTime || "No modification time",
      };
    });
  } catch (error) {
    console.error("❌ Error fetching updated hours:", error);
    return [];
  }
};

  // ✅ Delete handler - Fixed to track by hop name
  const handleDeleteHour = async (hour) => {
    // Set the deleting state to the specific hop name
    setDeletingHopName(hour.name);
    
    try {
      const requestPayload = {
        action: "delete",
        names: [hour.name],
        ID: EncryptedInstanceId,
        InstanceAlias: instanceAlias,
        Email: email,
        UserName: username,
        confirmation:"true",
        region,
        awsAccount: customerAWSAccountId,
      };

      const response = await axiosInstance.post(
        endpoints.addhours.addhop,
        requestPayload
      );

      if (response.data.statusCode === 400) {
        throw new Error(response.data.body);
      }

      console.log("Deleted HOP:", response.data);

      const updatedData = await fetchHoursOfOperation();
      setHopList(updatedData || []); // ✅ safe update
    } catch (error) {
      console.error("Delete failed:", error.message);
      alert(`Failed to delete: ${error.message}`);
    } finally {
      // Clear the deleting state
      setDeletingHopName(null);
      setConfirmDeleteHour(null);
    }
  };

  // ✅ Safe counts
  const totalCount = Array.isArray(hopList) ? hopList.length : 0;
  const filteredCount = Array.isArray(filteredData) ? filteredData.length : 0;

  // ✅ Show Add Form
  if (showAddForm) {
    return (
      <AddHoursPage
        onClose={() => setShowAddForm(false)}
        onHoursAdded={handleHoursAdded}
        instanceAlias={instanceAlias}
        instanceId={instanceId}
        customerAWSAccountId={customerAWSAccountId}
        region={region}
        existingHours={hopList}
      />
    );
  }

  // ✅ Show Edit Form
  if (editinghours) {
    return (
      <EditHoursPage
        hour={editinghours}
        onClose={() => setEditinghours(null)}
        onUpdate={handleHoursUpdated}
        instanceAlias={instanceAlias}
        instanceId={instanceId}
        customerAWSAccountId={customerAWSAccountId}
        region={region}
      />
    );
  }

  return (
    <Box p={3}>
      <Typography variant="h6" className="phone-number-title">
        Hours of Operation list
      </Typography>

      {/* 🔍 Search + Add */}
      <Box display="flex" justifyContent="space-between" mb={2}>
        <TextField
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearchChange}
          className="search-textfield"
          sx={{ width: 300 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setShowAddForm(true)}
        >
          Add HOURS OF OPERATION
        </Button>
      </Box>

      {/* ✅ Empty state */}
      {totalCount === 0 ? (
        <Box textAlign="center" p={3}>
          <Typography>No Hours of Operation found</Typography>
          <Button
            variant="contained"
            sx={{ mt: 2 }}
            startIcon={<AddIcon />}
            onClick={() => setShowAddForm(true)}
          >
            Add First HOP
          </Button>
        </Box>
      ) : (
        <>
          <Paper elevation={3}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell><b>Name</b></TableCell>
                  <TableCell><b>Description</b></TableCell>
                  <TableCell><b>Time Zone</b></TableCell>
                  <TableCell><b>Tags</b></TableCell>
                  <TableCell><b>Arn</b></TableCell>
                  <TableCell>Actions</TableCell>
                  <TableCell>Last Modified Time</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredCount > 0 ? (
                  filteredData.map((hop, index) => (
                    <TableRow key={index} hover>
                      {/* Clickable name → Edit */}
                      <TableCell>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setEditinghours(hop);
                          }}
                          style={{
                            textDecoration: "underline",
                            color: "#1976d2",
                            cursor: "pointer",
                          }}
                        >
                          {hop.name}
                        </a>
                      </TableCell>

                      <TableCell>{hop.description || "No description"}</TableCell>
                      <TableCell>{hop.timeZone || "N/A"}</TableCell>
                      
                      <TableCell>
                        {Array.isArray(hop.tags) && hop.tags.length > 0 ? (
                          hop.tags.map((tag, idx) => (
                            <Chip
                              key={idx}
                              label={`${tag.key}: ${tag.value}`}
                              size="small"
                              sx={{ m: 0.3 }}
                            />
                          ))
                        ) : (
                          <Typography variant="body2" color="textSecondary">
                            No tags
                          </Typography>
                        )}
                      </TableCell>

                      {/* Copy ARN */}
                      <TableCell>
                        <Tooltip title={hop.arn}>
                          <IconButton onClick={() => handleCopy(hop.arn)}>
                            {copiedArn === hop.arn ? <CheckIcon /> : <ContentCopyOutlinedIcon />}
                          </IconButton>
                        </Tooltip>
                      </TableCell>

                      {/* Delete - Fixed: Only show loading for the specific row being deleted */}
                      <TableCell>
                        <IconButton
                          color="error"
                          onClick={() => setConfirmDeleteHour(hop)}
                          disabled={deletingHopName === hop.name}
                        >
                          {deletingHopName === hop.name ? (
                            <CircularProgress size={18} />
                          ) : (
                            <DeleteIcon />
                          )}
                        </IconButton>
                      </TableCell>
                      <TableCell>
                        {hop.lastModifiedTime}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography>No matching results</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Paper>

          {/* ✅ Footer */}
          <Divider sx={{ my: 2 }} />
        </>
      )}

      {/* ✅ Delete Confirmation Dialog - Fixed loading state */}
      <Dialog
        open={Boolean(confirmDeleteHour)}
        onClose={() => setConfirmDeleteHour(null)}
        PaperProps={{ sx: { minWidth: 400 } }}
      >
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent dividers>
          Are you sure you want to delete <strong>{confirmDeleteHour?.name}</strong>?
        </DialogContent>

        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            p: 2,
            bgcolor: "background.paper",
          }}
        >
          <Button 
            variant="outlined" 
            onClick={() => setConfirmDeleteHour(null)}
            disabled={deletingHopName === confirmDeleteHour?.name}
          >
            No
          </Button>
          <Button
            color="error"
            variant="contained"
            onClick={() => confirmDeleteHour && handleDeleteHour(confirmDeleteHour)}
            disabled={deletingHopName === confirmDeleteHour?.name}
            startIcon={
              deletingHopName === confirmDeleteHour?.name ? (
                <CircularProgress size={18} color="inherit" />
              ) : null
            }
          >
            {deletingHopName === confirmDeleteHour?.name ? "Deleting..." : "Yes, Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default HoursOperationPage;